module.exports = __webpack_public_path__ + "static/img/img_home_c_sy.0445ad81.png";